export const DOCUMENT_PARSE_ACCEPT = '.pdf,.doc,.docx,.jpg,.jpeg,.png,.tif,.tiff';
export const DOCUMENT_PARSE_FILE_HINT = 'PDF, Word, or image (.pdf, .doc, .docx, .jpg, .png, .tif) — max 10 MB';
export const DOCUMENT_PARSE_UNSUPPORTED_MESSAGE = 'Only PDF, Word, and image files (.pdf, .doc, .docx, .jpg, .jpeg, .png, .tif, .tiff) are supported.';
const IMAGE_EXTENSIONS = new Set(['jpg', 'jpeg', 'png', 'tif', 'tiff']);
export function getDocumentExtension(fileName) {
    const base = fileName.trim().split(/[/\\]/).pop() ?? '';
    const dot = base.lastIndexOf('.');
    return dot >= 0 ? base.slice(dot + 1).toLowerCase() : '';
}
/**
 * Detect parse workflow kind from file name.
 * PDF, Word, and common Textract image types are supported.
 */
export function detectDocumentParseKind(fileName) {
    const ext = getDocumentExtension(fileName);
    if (ext === 'pdf')
        return 'pdf';
    if (ext === 'doc' || ext === 'docx')
        return 'word';
    if (IMAGE_EXTENSIONS.has(ext))
        return 'image';
    throw new Error(DOCUMENT_PARSE_UNSUPPORTED_MESSAGE);
}
export function isAllowedDocumentParseFile(fileName) {
    try {
        detectDocumentParseKind(fileName);
        return true;
    }
    catch {
        return false;
    }
}
